import { useContext } from "react";
import ReactComponents from "react-antd-styled-components2";
import { Provider } from "react-redux";
import { BrowserRouter, useMatch, useRoutes } from "react-router-dom";
import { Normalize } from "styled-normalize";
import { decryptToken } from "./api/utils";
import AppLogo from "./components/AppLogo";
import BrandLogo from "./components/BrandLogo";
import UserInfo from "./components/UserInfo";
import AppEnums from "./config/AppEnums";
import { GlobalStyles } from "./config/GlobalStyle";
import { mainRoutes } from "./config/Routes";
import defaultConfig from "./config/defaultConfig";
import { useRouteConfigAM } from "./config/routeConfigAM";
import { useRoutesConfigAdmin } from "./config/routeConfigAdmin";
import { useRouteConfigParent } from "./config/routeConfigParent";
import { useRouteConfigFinance } from "./config/routeConfigFinance";
import AppContextProvider from "./context/AppContextProvider";
import { useLayoutContext } from "./context/AppContextProvider/LayoutContextProvider";
import { useSidebarContext } from "./context/AppContextProvider/SidebarContextProvider";
import { useThemeContext } from "./context/AppContextProvider/ThemeContextProvider";
import AppThemeProvider from "./context/AppThemeProvider";
import AuthContextProvider, {
  AuthContext,
} from "./context/AuthContextProvider";
import { store } from "./redux/store";
import AppErrorBoundary from "./components/ErrorBoundary/AppErrorBoundary";

const Root = () => {
  const token = localStorage.getItem("token");
  console.log(token, "Root token");
  const userRole = localStorage.getItem("role"); // Fetch role from localStorage

  const { checkTokenExpiry } = useContext(AuthContext);

  const { PublicLayout, PrivateLayout } = ReactComponents("CRM");

  let dToken = token;
  let validToken = true;
  let expired = false;
  if (token) {
    dToken = decryptToken(token);
    expired = checkTokenExpiry(dToken);
  }
  const routes = useRoutes(mainRoutes);
  const loginPath = useMatch("/");
  const signupPath = useMatch("/signup");
  const forgotPath = useMatch("/forgot-password");

  const routeConfigParent = useRouteConfigParent();
  const routeConfigAdmin = useRoutesConfigAdmin();
  const routeConfigAM = useRouteConfigAM();
  const routeConfigFinance = useRouteConfigFinance();

  const normalizedRole = (userRole || "").trim();
  let routeConfig;
  switch (normalizedRole) {
    case "Customer":
      routeConfig = routeConfigAdmin;
      break;
    case "Manager":
      routeConfig = routeConfigParent;
      break;
    case "Parent":
      routeConfig = routeConfigAM;
      break;
    case "Finance":
      routeConfig = routeConfigFinance;
      break;
    default:
      routeConfig = routeConfigAdmin;
      break;
  }

  if (!Array.isArray(routeConfig)) {
    routeConfig = routeConfigAdmin;
  }

  const SideContent = () => {
    return (
      <div
        style={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* <div
          style={{
            fontWeight: "bold",
            fontSize: 20,
            color: customColors.black,
            textAlign: "center",
            marginBottom: 10,
          }}
        >
          MyLEAP Portal
        </div> */}

        <img
          src={"/assets/images/cover.png"}
          alt="myLeap Cover"
          width={400}
          style={{ borderRadius: 10 }}
        />
      </div>
    );
  };

  try {
    if (loginPath || signupPath || forgotPath) {
      return token && validToken && !expired ? (
        <PrivateLayout
          routes={routes}
          routesConfig={routeConfig} // Using the role-specific route config
          defaultConfig={defaultConfig}
          redirect={true}
          token={dToken}
          enums={AppEnums}
          useLayoutContext={useLayoutContext}
          useThemeContext={useThemeContext}
          useSidebarContext={useSidebarContext}
          AuthContext={AuthContext}
          brandLogo={BrandLogo}
          appLogo={AppLogo}
          userInfo={UserInfo}
        />
      ) : (
        routes
      );
    } else {
      return token && validToken && !expired ? (
        <PrivateLayout
          routes={routes}
          routesConfig={routeConfig}
          defaultConfig={defaultConfig}
          token={dToken}
          enums={AppEnums}
          useLayoutContext={useLayoutContext}
          useThemeContext={useThemeContext}
          useSidebarContext={useSidebarContext}
          AuthContext={AuthContext}
          brandLogo={BrandLogo}
          appLogo={AppLogo}
          userInfo={UserInfo}
        />
      ) : (
        <PublicLayout
          routes={routes}
          redirect={true}
          expired={expired}
          brandLogo={BrandLogo}
          appLogo={AppLogo}
          AuthContext={AuthContext}
          SideContent={SideContent}
        />
      );
    }
  } catch (error) {
    console.error("Failed to load Root Component!", error);
    return (
      <div style={{ padding: 48, textAlign: "center" }}>
        <h2>Unable to load the application</h2>
        <p>Please refresh the page or sign in again.</p>
      </div>
    );
  }
};

const App = () => (
  <Provider store={store}>
    <AppContextProvider>
      <AppThemeProvider>
        <AuthContextProvider>
          <BrowserRouter>
            <AppErrorBoundary>
              <GlobalStyles />
              <Normalize />
              <Root />
            </AppErrorBoundary>
          </BrowserRouter>
        </AuthContextProvider>
      </AppThemeProvider>
    </AppContextProvider>
  </Provider>
);

export default App;
